import { StompConfig } from '@stomp/ng2-stompjs';
import { Urls } from './url';
import * as SockJS from 'sockjs-client';
import { environment } from '../../environments/environment';

export const stompConfig: StompConfig = {
  url: socketProvider,
  headers: { },
  heartbeat_in: 0,
  heartbeat_out: 20000,
  reconnect_delay: 5000,
  debug: !environment.production
};

export function socketProvider() {
  return new SockJS(`${Urls.getBaseUrl()}/argos-websocket`);
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/websocket-config.ts